/**
 * Chips Mount Service for Native Interactive Site Map
 *
 * Resolves where the map chips bar belongs in the header: on desktop it mounts inside the
 * title-wrapper, before the Filter button; on mobile it appends directly to the header,
 * unchanged from prior behavior.
 *
 * @module nativeInteractiveSiteMap/services/chipsMountService
 */

export default function createChipsMountService(headerElement, isMobile) {
  function mount(chipsElement) {
    const titleWrapper = isMobile ? null : headerElement?.querySelector('[data-title-wrapper]');
    const filterButton = titleWrapper?.querySelector('[data-filter-button]');

    if (titleWrapper && filterButton) {
      titleWrapper.insertBefore(chipsElement, filterButton);
      return;
    }

    headerElement?.appendChild(chipsElement);
  }

  return { mount };
}
